import React, { useState } from "react";
import { Button, Card, Form, InputGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useRequestForPayoutMutation } from "../../app/features/apiSlice";
import { formatNumberToLocal, toastError, toastSuccess } from "../../helpers";

const RequestPayout = ({ balance, recurringPayment }) => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const [loading, setLoading] = useState(false);
  // const [amount, setAmount] = useState(Number(balance));
  const amount = Number(balance);

  const [requestForPayout] = useRequestForPayoutMutation();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (amount <= 0) {
        toastError("", t("amountCannotBeZero"));
        setLoading(false);
        return false;
      }
      const data = { amount, language: lang };
      const response = await requestForPayout(data).unwrap();
      if (response?.error) {
        toastError(response, t("error.serverNotResponding"));
      } else {
        toastSuccess(response?.message);
      }
    } catch (err) {
      toastError(err, t("error.serverNotResponding"));
    }
    setLoading(false);
  };
  return (
    <>
      <Card bg="dark1" className="my-2 my-md-3 text-light">
        <Card.Header>
          {t("availableForWithdrawal")}: {`CHF ${formatNumberToLocal(balance)}`}
        </Card.Header>
        <Card.Body>
          <div className="d-flex flex-column flex-md-row align-items-start justify-content-between gap-3">
            <Form onSubmit={handleSubmit}>
              <InputGroup className="mb-1" size="sm">
                {/* <Form.Control
                  type="text"
                  name="amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  min="0"
                  style={{ maxWidth: "12rem" }}
                /> */}
                <Button
                  type="submit"
                  variant="outline-warning"
                  disabled={loading}
                >
                  {t("request")}
                </Button>
              </InputGroup>
              <Form.Text className="text-white">
                {t("noteForPaymentRequest")}
              </Form.Text>
            </Form>
            <div className="text-muted" style={{ minWidth: 200 }}>
              <div className="text-light mb-1">
                <span className="fw-semibold">{t("nextRecurringPayment")}:</span> {recurringPayment}
              </div>
              <div className="text-white small">
                {t("noteForRecurringPaymentRequest")}
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default RequestPayout;
